// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"945":"dashboard","966":"login"}[chunkId] + "." + {"945":"676d0187","966":"6b6ef0f4"}[chunkId] + ".js";
};